import { render } from "./moa-timeline-content.vue?vue&type=template&id=6ce2d22e&scoped=true&ts=true"
import script from "./moa-timeline-content.vue?vue&type=script&lang=ts"
export * from "./moa-timeline-content.vue?vue&type=script&lang=ts"

import "./moa-timeline-content.vue?vue&type=style&index=0&id=6ce2d22e&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\Pfizer\\pfizer-covid-antiviral-digital\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce2d22e"]])

export default __exports__